export enum SignalRMethods {
    MailProgress = 'MailProgress',
    UpdateUserCount = 'UpdateUserCount',
    StatusChangeProgress = 'StatusChangeProgress',
}